import { useEffect } from 'react';
export function useMinPanelHeight(headerRef, footerRef, callback) {
    useEffect(() => {
        var _a, _b;
        const minPanelHeight = (((_a = headerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 28) /* defaults to estimated height */ +
            (((_b = footerRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight) || 61) +
            16 /* padding-top above header  */ +
            3; /* footer divider & border pixels */
        callback(minPanelHeight);
    }, [headerRef, footerRef, callback]);
}
